module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-09 at 3.32.18 PM.626900f0.png";